import { ToDosBoard } from "src/components/to-dos/ToDosBoard";
import { useRouteParams } from "src/hooks/useRouteParams";
import { useTeamMembersQuery } from "src/routes/projects/settings/TeamMembersTab.generated";
import { ProjectParams } from "src/routes/routesDef";
import { queryResult } from "src/utils";

export function ToDosPage() {
  const { projectId } = useRouteParams<ProjectParams>();
  const query = useTeamMembersQuery({ variables: { projectId: projectId } });
  return queryResult(query, {
    data: (result) => {
      return <ToDosBoard projectId={projectId} teamMembers={result.project.availableAssignees} />;
    },
  });
}
